/**
 * Block 11 (2026-05-27): ФОП ЗСО expense categories (ПКУ ст.177.4).
 *
 * 15 категорій витрат для ФОП на загальній системі. Reused у:
 *   - ManualOperationEditor (conditional recognition section)
 *   - FopZsoQuarterlyEditor (breakdown table labels)
 */
export type FopExpenseCategory =
  | 'MATERIALS_GOODS_FUEL'
  | 'EMPLOYEE_SALARY'
  | 'EMPLOYEE_ESV'
  | 'EMPLOYEE_INSURANCE'
  | 'OTHER_TAXES'
  | 'LICENSES_PERMITS'
  | 'ROYALTIES'
  | 'DEPRECIATION'
  | 'REPAIR_FIXED_ASSETS'
  | 'LIQUIDATION_FIXED_ASSETS'
  | 'RENT_PREMISES'
  | 'UTILITIES'
  | 'BANK_SERVICES'
  | 'COMMUNICATION_INTERNET'
  | 'OTHER_ALLOWED';

export const FOP_EXPENSE_CATEGORY_LABELS: Record<FopExpenseCategory, string> = {
  MATERIALS_GOODS_FUEL: 'Сировина, товари, паливо, запчастини',
  EMPLOYEE_SALARY: 'Заробітна плата найманих працівників',
  EMPLOYEE_ESV: 'ЄСВ за найманих працівників',
  EMPLOYEE_INSURANCE: 'Обов\'язкове страхування працівників',
  OTHER_TAXES: 'Інші податки і збори',
  LICENSES_PERMITS: 'Ліцензії, дозволи, сертифікати',
  ROYALTIES: 'Роялті',
  DEPRECIATION: 'Амортизація ОЗ',
  REPAIR_FIXED_ASSETS: 'Поточний ремонт ОЗ',
  LIQUIDATION_FIXED_ASSETS: 'Ліквідація ОЗ (залишкова вартість)',
  RENT_PREMISES: 'Оренда приміщень/обладнання',
  UTILITIES: 'Комунальні послуги',
  BANK_SERVICES: 'Банківські послуги',
  COMMUNICATION_INTERNET: 'Зв\'язок, інтернет',
  OTHER_ALLOWED: 'Інші дозволені витрати',
};

export const FOP_EXPENSE_CATEGORY_OPTIONS: ReadonlyArray<{
  value: FopExpenseCategory;
  label: string;
}> = Object.entries(FOP_EXPENSE_CATEGORY_LABELS).map(([k, label]) => ({
  value: k as FopExpenseCategory,
  label,
}));
